<template>
  <div class="orderlist bj order-container">
    <!-- 表单搜索 start -->
    <Filtersearch
      ref="Filtersearchref"
      :list="Filtersearchlist"
      :fromdata="from1"
      @Refresh="Refresh"
      @search="search"
    >
      <template v-slot:right>
        <el-button @click="exportHandle" type="success" icon="el-icon-download"
          >导出</el-button
        >
      </template>
    </Filtersearch>
    <!-- 表单搜索 end -->

    <div class="auto-table-flex mt20">
      <el-table
        :data="tableData"
        height="100%"
        v-loading="loading"
        border
        :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
      >
        <el-table-column
          prop="logisticBusinessName"
          align="center"
          label="集配中心"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="supplierName"
          align="center"
          label="供应商名称"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="sellerTaxNum"
          align="center"
          label="税号"
          min-width="150"
        >
          <template slot-scope="scope">
            {{ scope.row.sellerTaxNum || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="supplierMobile"
          align="center"
          label="供应商电话"
          min-width="120"
        >
          <template slot-scope="scope">
            {{ scope.row.supplierMobile || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orderNo"
          align="center"
          label="订单号"
          min-width="180"
        ></el-table-column>
        <el-table-column
          prop="productName"
          align="center"
          label="商品名称"
          min-width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="invoiceStatusName"
          align="center"
          label="开票状态"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="invoiceAmount"
          align="center"
          label="开票金额"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="memberName"
          align="center"
          label="用户姓名"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="memberMobile"
          align="center"
          label="用户电话"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="invoiceTaxRate"
          align="center"
          label="税率"
          min-width="80"
        >
          <template slot-scope="scope">
            {{ scope.row.invoiceTaxRate
            }}{{
              scope.row.invoiceTaxRate && scope.row.invoiceTaxRate !== "免税"
                ? ""
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="invoiceTaxCode"
          align="center"
          label="税收分类编码"
          min-width="150"
        ></el-table-column>
      </el-table>
    </div>

    <div class="fy">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="from1.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="from1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import Filtersearch from "@/components/Filtersearch.vue";

export default {
  name: "SupplierInvoiceDetail",
  components: {
    Filtersearch,
  },
  data() {
    return {
      Filtersearchlist: [
        {
          type: "input",
          name: "供应商名称",
          clearable: true,
          model: "search_supplier_name",
          placeholder: "请输入供应商名称",
        },
        {
          type: "input",
          name: "供应商电话",
          clearable: true,
          model: "search_supplier_mobile",
          placeholder: "请输入供应商电话",
        },
        {
          type: "input",
          name: "会员名称",
          clearable: true,
          model: "search_member_name",
          placeholder: "请输入会员名称",
        },
        {
          type: "input",
          name: "会员电话",
          clearable: true,
          model: "search_member_mobile",
          placeholder: "请输入会员电话",
        },
        {
          type: "input",
          name: "订单号",
          clearable: true,
          model: "search_order_no",
          placeholder: "请输入订单号",
        },
        {
          type: "select",
          name: "开票状态",
          clearable: true,
          model: "search_apply_status",
          placeholder: "请选择开票状态",
          label: "label",
          value: "value",
          selectoption: [
            { label: "全部", value: "0" },
            { label: "未申请", value: "1" },
            { label: "未开票", value: "2" },
            { label: "开票中", value: "3" },
            { label: "开票成功", value: "4" },
          ],
        },
        {
          type: "select",
          name: "集配中心",
          clearable: true,
          model: "search_logistic_business_id",
          placeholder: "请选择集配中心",
          label: "name",
          value: "id",
          selectoption: [],
          selectoptionname: "logisticsList",
        },
        {
          type: "input",
          name: "税号",
          clearable: true,
          model: "search_seller_tax_num",
          placeholder: "请输入税号",
        },
        {
          type: "select",
          name: "状态",
          clearable: true,
          model: "search_supplier_invoice_auth",
          placeholder: "请选择状态",
          label: "label",
          value: "value",
          selectoption: [
            { label: "全部", value: "0" },
            { label: "可开票", value: "1" },
            { label: "不可开票", value: "2" },
          ],
        },
        {
          type: "daterange",
          name: "下单时间",
          clearable: false,
          model: "time_range",
          startmodel: "start_date",
          endmodel: "end_date",
          startplaceholder: "开始日期",
          endplaceholder: "结束日期",
        },
      ],
      loading: false,
      from1: {
        search_supplier_name: "",
        search_supplier_mobile: "",
        search_member_name: "",
        search_member_mobile: "",
        search_order_no: "",
        search_apply_status: "0",
        search_logistic_business_id: "",
        search_seller_tax_num: "",
        search_supplier_invoice_auth: "0",
        start_date: "",
        end_date: "",
        time_range: [],
        page: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
    };
  },
  created() {
    this.initDefaultDate();
    this.getLogisticsList();
    // 获取 URL 传参
    const query = this.$route.query;
    if (query.uscc) {
      this.from1.search_seller_tax_num = query.uscc;
    }
    if (query.invoiceStartTime) {
      this.from1.start_date = query.invoiceStartTime;
    }
    this.getList();
  },
  methods: {
    initDefaultDate() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      const formatDate = (date) => {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "-" + m + "-" + d;
      };
      this.from1.start_date = formatDate(start);
      this.from1.end_date = formatDate(end);
      this.from1.time_range = [this.from1.start_date, this.from1.end_date];
    },
    getLogisticsList() {
      this.$api.general.businessList().then((res) => {
        const logisticsItem = this.Filtersearchlist.find(
          (item) => item.selectoptionname === "logisticsList"
        );
        if (logisticsItem) {
          logisticsItem.selectoption = res.data;
        }
      });
    },
    getList() {
      this.loading = true;
      this.$api.invoice
        .invoiceDetailList(this.from1)
        .then((res) => {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    search(e) {
      this.from1 = e;
      this.from1.page = 1;
      this.getList();
    },
    Refresh() {
      this.from1 = {
        search_supplier_name: "",
        search_supplier_mobile: "",
        search_member_name: "",
        search_member_mobile: "",
        search_order_no: "",
        search_apply_status: "",
        search_logistic_business_id: "",
        search_seller_tax_num: "",
        search_supplier_invoice_auth: "",
        search_invoice_tax_rate: "",
        start_date: "",
        end_date: "",
        time_range: [],
        page: 1,
        pageSize: 10,
      };
      this.initDefaultDate();
      this.tool.getResult(this.from1, window.location.href);
      this.getList();
    },
    handleSizeChange(val) {
      this.from1.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.from1.page = val;
      this.getList();
    },
    async exportHandle() {
      this.$confirm("确定导出供应商开票详情列表吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          const query = {
            ...this.from1,
            token: sessionStorage.getItem("token"),
          };
          delete query.page;
          delete query.pageSize;
          await this.$api.invoice.invoiceDetailExport(query);
          this.goExportCenter();
        } catch (err) {
          console.log("ajax invoiceDetailExport err", err);
        }
      });
    },
    goExportCenter() {
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.order-container {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  height: 100%;
  box-sizing: border-box;
  padding: 10px;

  .auto-table-flex {
    flex-grow: 1;
    overflow-y: hidden;
  }

  .fy {
    box-sizing: border-box;
    padding: 10px 20px;
  }
}
</style>
